/*
export function exportToCsv(filename, rows, headers) {
    // Procesar las cabeceras
    const headerString = headers.join(',');
    
    // Procesar cada fila
    const processRow = (row) => {
        return headers.map(header => {
            return `"${row[header]}"`; // Asegura que los datos estén en formato CSV correcto
        }).join(',');
    };

    // Unir todo el contenido: Cabeceras y filas
    let csvContent = headerString + '\n' + rows.map(e => processRow(e)).join("\n");

    let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    let link = document.createElement("a");
    if (link.download !== undefined) {
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
*/
/* export function exportToCsv(filename, rows, headers) {
    // Filtrar las cabeceras para excluir aquellas que empiezan con 'id'
    const filteredHeaders = headers.filter(header => !header.startsWith('id'));

    // Procesar las cabeceras filtradas
    const headerString = filteredHeaders.join(',');

    // Procesar cada fila, excluyendo los valores de las columnas que empiezan con 'id'
    const processRow = (row) => {
        return filteredHeaders.map(header => {
            return `"${row[header]}"`; // Asegura que los datos estén en formato CSV correcto
        }).join(',');
    };

    // Unir todo el contenido: Cabeceras y filas
    let csvContent = headerString + '\n' + rows.map(e => processRow(e)).join("\n");

    let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    let link = document.createElement("a");
    if (link.download !== undefined) {
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
} */
export async function exportToCsv(filename, rows, headers) {
  // Filtrar las cabeceras para excluir aquellas que empiezan con 'id'
  const filteredHeaders = headers.filter((header) => !header.startsWith("id"));
  const headerString = filteredHeaders.join(",");

  // Procesar cada fila, excluyendo los valores de las columnas que empiezan con 'id'
  const processRow = (row) => {
    return filteredHeaders.map((header) => `"${row[header]}"`).join(",");
  };

  // Unir todo el contenido: Cabeceras y filas
  let csvContent =
    headerString + "\n" + rows.map((e) => processRow(e)).join("\n");

  // Convertir el contenido CSV a un Blob
  let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  // Crear el hash SHA-256 del contenido del CSV
  const hash = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(csvContent)
  );
  const hashArray = Array.from(new Uint8Array(hash)); // Convertir el buffer a un array de bytes
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(""); // Convertir bytes a hexadecimal

  // Descargar el archivo CSV
  let link = document.createElement("a");
  if (link.download !== undefined) {
    let url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Crear y descargar el archivo de hash
  let hashBlob = new Blob([hashHex], { type: "text/plain;charset=utf-8;" });
  let hashLink = document.createElement("a");
  if (hashLink.download !== undefined) {
    let hashUrl = URL.createObjectURL(hashBlob);
    hashLink.setAttribute("href", hashUrl);
    hashLink.setAttribute("download", filename + ".sha256");
    hashLink.style.visibility = "hidden";
    document.body.appendChild(hashLink);
    hashLink.click();
    document.body.removeChild(hashLink);
  }
}
